import { CheckOutline } from "components/icons/CheckOutline";
import { RecentDocument } from "v2/store/entityDocumentsApi";
import { FileRow } from "./FileRow";
import { InkleFileRow } from "./InkleFileRow";

type UploadedDocumentRowProps = {
  document: RecentDocument;
  // Inkle-uploaded docs are read-only: view + download, no replace/delete.
  readOnly?: boolean;

  entityId?: string;
  onReplaceClick?: (document: RecentDocument) => void;
  onDeleteClick?: (document: RecentDocument) => void;
};

export const UploadedDocumentRow = ({
  document,
  readOnly = false,
  entityId,
  onReplaceClick,
  onDeleteClick,
}: UploadedDocumentRowProps) => {
  const handleReplaceClick = (): void => onReplaceClick?.(document);
  const handleDeleteClick = (): void => onDeleteClick?.(document);

  return (
    <div className="t-flex t-items-start t-gap-2.5 t-rounded-lg t-px-2 t-py-2">
      <span className="t-mt-0.5 t-flex t-h-4 t-w-4 t-shrink-0 t-items-center t-justify-center t-text-green-70">
        <CheckOutline />
      </span>
      <div className="t-min-w-0 t-flex-1">
        <div className="t-text-subtext-sm t-text-text-60">{document.name}</div>
        <div className="t-mt-1 t-flex t-flex-col t-gap-1">
          {document.files.map((file) =>
            readOnly ? (
              <InkleFileRow key={file.uuid} file={file} />
            ) : (
              <FileRow
                key={file.uuid}
                file={file}
                section={document.name}
                entityId={entityId}
                onReplaceClick={handleReplaceClick}
                onDeleteClick={handleDeleteClick}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};
